export default __webpack_public_path__ + "static/media/493.307a43fa.png";